/* eslint-disable import/no-unresolved */
import { LoanDetails } from "src/helpers/FormDetails/ProposalDetails/interfaces";
import * as types from "../../Types/loanDetails";

export const setLoanDetails = (payload: LoanDetails) => ({
  type: types.SET_LOAN_DETAILS,
  payload
});

export const saveLoanDetails = (
  apiData: any,
  masterData: any,
  riderMaster: Record<string, any>,
  leadId: string
) => ({
  type: types.SAVE_LOAN_DETAILS,
  payload: { apiData, masterData, riderMaster, leadId }
});

export const toggleRiderForm = (show: boolean) => ({
  type: types.TOGGLE_RIDER_FORM,
  payload: show
});

export const setRiderSelectionLocked = (payload: boolean) => ({
  type: types.SET_RIDER_SELECTION_LOCKED,
  payload
});
